import { type SnapshotId, isNullable } from '@ipfabric/utils';
import { createContext, useContext } from 'react';

interface DiscoverySettingsContextProps {
  newSnapshot: boolean;
  showUpdateFromGlobalSettingsButton: boolean;
  snapshotId: SnapshotId | null;
}

export const DiscoverySettingsContext =
  createContext<DiscoverySettingsContextProps | null>({
    newSnapshot: false,
    showUpdateFromGlobalSettingsButton: false,
    snapshotId: null,
  });

export const useDiscoverySettingsContext =
  (): DiscoverySettingsContextProps => {
    const context = useContext(DiscoverySettingsContext);
    if (isNullable(context)) {
      throw new Error(
        'useDiscoverySettingsContext must be used within provider',
      );
    }
    return context;
  };
